import api from '../api';

function findAll() {
  return new Promise((resolve, reject) => {
    return api.get('/logs/email')
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
}

function resendEmail(id) {
  return new Promise((resolve, reject) => {
    return api.post(`/logs/email/resend/${id}`)
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
}

export default {
  findAll,
  resendEmail,
};
